/* Yumei Glass – hover-intent mega menu, card deck (click/swipe/arrows/dots, tilt+holo), sparks, carousels */
(()=>{
  if(window.__ymGlass)return;window.__ymGlass=true;
  const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine=matchMedia('(hover: hover) and (pointer: fine)');

  /* ---------- mega menu: click-to-toggle (default) + optional hover intent ---------- */
  (()=>{
    const nav=document.querySelector('.ym-nav');if(!nav)return;
    const megas=[...nav.querySelectorAll('details.ym-mega')];if(!megas.length)return;
    const hover=nav.dataset.ymHover==='true';
    const OPEN=+nav.dataset.ymOpen||150,CLOSE=+nav.dataset.ymClose||400;
    let ot=null,ct=null,hoverAt=0,lastMove=0,lx=0,ly=0;
    if(hover)addEventListener('mousemove',e=>{if(Math.abs(e.clientX-lx)+Math.abs(e.clientY-ly)>3){lastMove=performance.now();lx=e.clientX;ly=e.clientY}},{passive:true});
    const sum=d=>d.querySelector(':scope > summary');
    const aria=d=>{const s=sum(d);if(s)s.setAttribute('aria-expanded',d.open?'true':'false')};
    const sync=()=>{document.body.classList.toggle('ym-mega-open',megas.some(d=>d.open));megas.forEach(aria)};
    const set=(d,o)=>{if(d.open!==o)d.open=o;aria(d)};
    const only=d=>{megas.forEach(o=>{if(o!==d)set(o,false)});if(d)set(d,true);sync()};
    const closeAll=()=>{clearInterval(ot);clearTimeout(ct);only(null)};
    megas.forEach(d=>{
      const s=sum(d);
      d.addEventListener('toggle',()=>{setTimeout(sync,0)});
      s.addEventListener('click',e=>{
        e.preventDefault();clearInterval(ot);clearTimeout(ct);
        if(d.open&&hover&&Date.now()-hoverAt<700){setTimeout(sync,0);return}
        if(d.open){set(d,false);sync()}else only(d);
        setTimeout(sync,0); /* re-assert aria after Origin's own summary click handler */
      });
      if(hover){
        /* hover intent: open only after the pointer has RESTED on the summary for OPEN ms,
           so sweeping down across other nav rows towards the open panel never swaps panels */
        s.addEventListener('mouseenter',()=>{
          if(!fine.matches)return;clearTimeout(ct);clearInterval(ot);
          if(d.open)return;
          ot=setInterval(()=>{
            if(!s.matches(':hover')){clearInterval(ot);return}
            if(performance.now()-lastMove>=OPEN){clearInterval(ot);hoverAt=Date.now();only(d)}
          },40);
        });
        d.addEventListener('mouseenter',()=>{if(d.open)clearTimeout(ct)});
        d.addEventListener('mouseleave',()=>{
          if(!fine.matches||!d.open)return;clearTimeout(ct);
          ct=setTimeout(()=>{if(!d.matches(':hover')){set(d,false);sync()}},CLOSE);
        });
      }
    });
    document.addEventListener('click',e=>{if(!e.target.closest('details.ym-mega'))closeAll()});
    document.addEventListener('keydown',e=>{if(e.key!=='Escape')return;const d=megas.find(x=>x.open);if(d){closeAll();const s=sum(d);s&&s.focus()}});
    sync();
  })();

  /* ---------- hero card deck ---------- */
  function initDeck(stage){
    if(stage.__ym)return;stage.__ym=true;
    const slides=[...stage.querySelectorAll('.ym-slide')];if(!slides.length)return;
    const dots=[...stage.querySelectorAll('[data-ym-dot]')];
    const cap=stage.querySelector('[data-ym-cap]');
    const n=slides.length;let cur=0,timer=null;
    const set=(el,k,v)=>{el.querySelector(k).textContent=v;el.querySelector(k).hidden=!v};
    function render(animate=true){
      slides.forEach((s,i)=>{let d=i-cur;if(d>n/2)d-=n;if(d<-n/2)d+=n;
        s.dataset.pos=Math.abs(d)>2?'hide':String(d);s.setAttribute('aria-hidden',d!==0);s.tabIndex=d===0?0:-1;
        if(d!==0)resetTilt(s)});
      dots.forEach((b,i)=>{b.classList.toggle('is-on',i===cur);b.setAttribute('aria-selected',i===cur)});
      if(cap){const s=slides[cur];cap.href=s.getAttribute('href');
        const fill=()=>{set(cap,'.ym-cap__game',s.dataset.game);set(cap,'.ym-cap__name',s.dataset.name);set(cap,'.ym-cap__rar',s.dataset.rarity);set(cap,'.ym-cap__price',s.dataset.price);
          cap.classList.toggle('is-out',s.dataset.available==='0')};
        if(animate&&!reduce){cap.classList.add('is-swap');setTimeout(()=>{fill();cap.classList.remove('is-swap')},220)}else fill();}
    }
    const go=i=>{cur=(i+n)%n;render();restart()};
    stage.querySelector('[data-ym-prev]')?.addEventListener('click',()=>go(cur-1));
    stage.querySelector('[data-ym-next]')?.addEventListener('click',()=>go(cur+1));
    dots.forEach((b,i)=>b.addEventListener('click',()=>go(i)));
    stage.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'){go(cur-1);e.preventDefault()}if(e.key==='ArrowRight'){go(cur+1);e.preventDefault()}});
    /* click on a side card rotates to it; click on the active card opens the product */
    let swiped=false;
    slides.forEach((s,i)=>s.addEventListener('click',e=>{if(swiped||i!==cur){e.preventDefault();if(!swiped)go(i)}}));
    /* swipe / drag (v2): pointer capture, drag clamped to ±1 card, snap on release, max one step per gesture */
    const deck=stage.querySelector('[data-ym-deck]');let x0=null,y0=0,id=null,dragging=false,lastDx=0;
    const lim=()=>Math.max(60,Math.min(140,deck.offsetWidth*.45));
    const clampDx=dx=>Math.max(-lim(),Math.min(lim(),dx*.5));
    deck.addEventListener('dragstart',e=>e.preventDefault());
    deck.querySelectorAll('img').forEach(i=>{i.draggable=false});
    deck.addEventListener('pointerdown',e=>{if(e.button!==0||x0!==null)return;x0=e.clientX;y0=e.clientY;id=e.pointerId;lastDx=0;dragging=false;swiped=false;clearInterval(timer)});
    deck.addEventListener('pointermove',e=>{if(x0===null||e.pointerId!==id)return;const dx=e.clientX-x0,dy=e.clientY-y0;
      if(!dragging){if(Math.abs(dx)<8||Math.abs(dx)<=Math.abs(dy)){if(Math.abs(dy)>12&&e.pointerType==='touch')cancel();return}
        dragging=true;swiped=true;try{deck.setPointerCapture(id)}catch(_){}deck.classList.add('is-dragging')}
      e.preventDefault();lastDx=dx;deck.style.setProperty('--drag',clampDx(dx).toFixed(1)+'px')});
    function finish(commit){const dx=lastDx,was=dragging;x0=null;dragging=false;lastDx=0;
      try{if(id!==null&&deck.hasPointerCapture&&deck.hasPointerCapture(id))deck.releasePointerCapture(id)}catch(_){}id=null;
      deck.classList.remove('is-dragging');deck.style.setProperty('--drag','0px');
      if(commit&&was&&Math.abs(dx)>45)go(dx<0?cur+1:cur-1);else restart();
      if(was)setTimeout(()=>swiped=false,80);else swiped=false}
    function cancel(){if(x0!==null)finish(false)}
    deck.addEventListener('pointerup',e=>{if(e.pointerId===id)finish(true)});
    deck.addEventListener('pointercancel',cancel);deck.addEventListener('lostpointercapture',()=>{if(dragging)finish(true)});
    deck.addEventListener('pointerleave',e=>{if(x0!==null&&!dragging)cancel()});
    addEventListener('blur',cancel);
    /* tilt + holo on the active card */
    function resetTilt(s){const c=s.querySelector('.ym-card');c.classList.remove('is-live');c.style.setProperty('--rx','0deg');c.style.setProperty('--ry','0deg')}
    if(!reduce){let raf=0;
      stage.addEventListener('pointermove',e=>{if(e.pointerType==='touch'&&x0!==null)return;const c=slides[cur].querySelector('.ym-card');const r=c.getBoundingClientRect();
        const x=Math.min(1,Math.max(0,(e.clientX-r.left)/r.width)),y=Math.min(1,Math.max(0,(e.clientY-r.top)/r.height));
        cancelAnimationFrame(raf);raf=requestAnimationFrame(()=>{c.classList.add('is-live');
          c.style.setProperty('--ry',((x-.5)*22).toFixed(2)+'deg');c.style.setProperty('--rx',((.5-y)*18).toFixed(2)+'deg');
          c.style.setProperty('--px',(x*100).toFixed(1)+'%');c.style.setProperty('--py',(y*100).toFixed(1)+'%');
          c.style.setProperty('--gx',(x*100).toFixed(1)+'%');c.style.setProperty('--gy',(y*100).toFixed(1)+'%')})});
      stage.addEventListener('pointerleave',()=>resetTilt(slides[cur]));}
    /* optional autoplay */
    function restart(){clearInterval(timer);if(stage.dataset.autoplay==='true'&&!reduce&&n>1)timer=setInterval(()=>{if(!document.hidden&&!stage.matches(':hover'))go(cur+1)},+stage.dataset.speed||5000)}
    render(false);restart();
    stage.ymGo=go;
  }
  const initAll=()=>document.querySelectorAll('[data-ym-stage]').forEach(initDeck);
  initAll();document.addEventListener('shopify:section:load',initAll);
  document.addEventListener('shopify:block:select',e=>{const s=e.target.closest('[data-ym-stage]');if(s&&s.ymGo){const i=[...s.querySelectorAll('.ym-slide')].indexOf(e.target);if(i>=0)s.ymGo(i)}});

  /* ---------- carousel arrows (section heads) ---------- */
  document.addEventListener('click',e=>{const b=e.target.closest('[data-ym-scroll]');if(!b)return;
    const tr=b.closest('.ym-block')?.querySelector('[data-ym-track]');if(tr)tr.scrollBy({left:(+b.dataset.ymScroll)*tr.clientWidth*.8,behavior:reduce?'auto':'smooth'})});

  /* ---------- gold sparks inside the hero ---------- */
  if(!reduce)document.querySelectorAll('[data-ym-hero] .ym-sparks').forEach(cv=>{
    const ctx=cv.getContext('2d');let w,h,dpr=Math.min(devicePixelRatio||1,2),ps=[],run=true;
    const N=innerWidth<990?24:56;
    const size=()=>{w=cv.clientWidth;h=cv.clientHeight;cv.width=w*dpr;cv.height=h*dpr;ctx.setTransform(dpr,0,0,dpr,0,0)};
    size();addEventListener('resize',size);
    for(let i=0;i<N;i++)ps.push({x:Math.random()*w,y:Math.random()*h,r:Math.random()*1.6+.3,v:Math.random()*.35+.08,a:Math.random()*.7+.2,p:Math.random()*6});
    new IntersectionObserver(es=>{run=es[0].isIntersecting;if(run)requestAnimationFrame(tick)}).observe(cv);
    document.addEventListener('visibilitychange',()=>{run=!document.hidden;if(run)requestAnimationFrame(tick)});
    function tick(ts){if(!run)return;ctx.clearRect(0,0,w,h);
      for(const s of ps){s.y-=s.v;s.x+=Math.sin((ts/1000)+s.p)*.15;if(s.y<-4){s.y=h+4;s.x=Math.random()*w}
        const tw=.55+.45*Math.sin(ts/600+s.p);ctx.beginPath();ctx.arc(s.x,s.y,s.r,0,6.283);
        ctx.fillStyle=`rgba(255,${190+Math.round(40*tw)},90,${(s.a*tw).toFixed(3)})`;ctx.shadowColor='rgba(255,179,6,.9)';ctx.shadowBlur=8;ctx.fill();}
      requestAnimationFrame(tick)}
    requestAnimationFrame(tick);
  });
})();

/* v4: product page – sticky add-to-cart + live status pill */
(function(){
  const bar=document.querySelector('[data-ym-satc]');
  const info=document.querySelector('.product__info-container');
  if(!info)return;
  const realBtn=()=>info.querySelector('button[name="add"]');
  const bis=()=>info.querySelector('bis-inline:not(.hidden)')||document.querySelector('bis-inline.btn:not(.hidden)');
  const priceText=()=>{const p=info.querySelector('.price');if(!p)return '';
    const el=p.classList.contains('price--on-sale')?p.querySelector('.price__sale .price-item--last'):p.querySelector('.price__regular .price-item--regular');
    return (el||p).textContent.trim()};
  const avail=()=>{const b=realBtn();return !!(b&&!b.disabled&&!b.hasAttribute('disabled'))};
  function sync(){
    const ok=avail();
    const pill=info.querySelector('[data-ym-avail]'),st=info.querySelector('[data-ym-status]');
    if(pill&&st){pill.textContent=ok?st.dataset.in:st.dataset.out;pill.classList.toggle('ym-pill--in',ok);pill.classList.toggle('ym-pill--out',!ok)}
    if(bar){const b=bar.querySelector('[data-ym-satc-btn]');b.textContent=ok?b.dataset.add:b.dataset.notify;b.classList.toggle('is-notify',!ok);
      const pr=bar.querySelector('[data-ym-satc-price]');const t=priceText();if(pr&&t)pr.textContent=t}
  }
  info.addEventListener('change',()=>{setTimeout(sync,450);setTimeout(sync,1200)});
  setTimeout(sync,800);
  if(!bar)return;
  document.body.classList.add('ym-has-satc');
  bar.querySelector('[data-ym-satc-btn]').addEventListener('click',()=>{
    const b=realBtn();
    if(avail()){b.click();return}
    const n=bis();
    if(n){n.scrollIntoView({behavior:'smooth',block:'center'});setTimeout(()=>n.click(),350)}
    else if(b){b.scrollIntoView({behavior:'smooth',block:'center'})}
  });
  let tk=0;const chk=()=>{tk=0;const t=info.querySelector('.product-form__buttons')||realBtn();if(!t)return;
    const past=t.getBoundingClientRect().bottom<0;
    bar.classList.toggle('is-on',past);bar.setAttribute('aria-hidden',past?'false':'true')};
  const q=()=>{if(!tk)tk=requestAnimationFrame(chk)};
  addEventListener('scroll',q,{passive:true});addEventListener('resize',q);setTimeout(chk,600);
})();
